import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { ConfirmModal } from 'components/shared/confirmModal/components/confirmModal';
import PrettyNumber from '../PrettyNumber';
const ReleaseNumberModal = ({ isShown, phoneNumbers, number, onHide, }) => {
    const { releaseAsyncStatus } = phoneNumbers;
    const isLoading = releaseAsyncStatus !== 'succeeded';
    const onRelease = useCallback(() => {
        if (!number) {
            return;
        }
        const { release, getItems } = phoneNumbers;
        release(number)
            .then(() => onHide())
            .then(() => getItems());
    }, [phoneNumbers, number, onHide]);
    if (!number) {
        return null;
    }
    return (_jsx(ConfirmModal, Object.assign({ isShown: isShown, headline: "Are you sure?", confirmText: "Confirm", cancelText: "Cancel", confirmProps: { isLoading }, confirm: onRelease, cancel: onHide }, { children: _jsxs("span", { children: ["You are about to release the phone number:", ' ', _jsx(PrettyNumber, { number: number })] }) })));
};
export default ReleaseNumberModal;
